import React from 'react';
import { useTranslation } from 'react-i18next';

import { EnhancedTabs } from '@swyftx/aviary/molecules/EnhancedTabs';
import { MarginOrderType } from '@swyftx/margin/build/types';

type Props = {
  tradeType: MarginOrderType;
  setTradeType: (tradeType: MarginOrderType) => void;
  fullWidth?: boolean;
};

const MarginTradePanelTypeTab: React.FC<Props> = ({ tradeType, fullWidth, setTradeType }) => {
  const { t } = useTranslation('margin');
  return (
    <EnhancedTabs
      className='px-12'
      variant='parent'
      size='lg'
      fullWidth={fullWidth}
      value={tradeType.toString()}
      tabs={[
        { value: MarginOrderType.Market.toString(), title: t(`tradeType.${MarginOrderType.Market}`) },
        { value: MarginOrderType.Limit.toString(), title: t(`tradeType.${MarginOrderType.Limit}`) },
        { value: MarginOrderType.Stop.toString(), title: t(`tradeType.${MarginOrderType.Stop}`) },
      ]}
      onChange={(val) => setTradeType(Number(val) as MarginOrderType)}
    />
  );
};

export { MarginTradePanelTypeTab };
